import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { MessageService } from '../../_services/message.service';


import { User } from '../../_models/user';
import { Globals } from '../../_globals/globals';
import {CuttingTable} from '../../_models/cutting_table';
import {CuttingTableType} from '../../_models/cutting_table_type';


@Injectable({
  providedIn: 'root'
})

export class CuttingTableService {

  constructor(
    private http: HttpClient,
    // private httpParams: HttpParams,
    private globals: Globals,
    private messageService: MessageService
  ) {}

  getCuttingTables(searchParams): Observable<CuttingTable[]> {

    console.log('-->--> Ejecutando servicio getCuttingTable');
    console.log(searchParams);
    console.log('---------------');

    let params = new HttpParams();

    if (searchParams !== null && searchParams !== undefined) {
      for (const key in searchParams) {
        // Para controlar que exista un elemento con esa key.
        if (searchParams.hasOwnProperty(key)) {
          params = params.set(key, searchParams[key]);
        }
      }
    }

    // Add safe, URL encoded search parameter if there is a search term
    const options = { params: params };

    return this.http.get<CuttingTable[]>(this.globals.apiUrl + '/cutting_table', options)
      .pipe(
        tap(  _ => this.log('get cutting_table')),
        catchError(this.handleError<CuttingTable[]>('getCuttingTable', null)
      ));
  }

  getCuttingTableTypes(searchParams): Observable<CuttingTableType[]> {

    console.log('-->--> Ejecutando servicio getCuttingTableTypes');
    console.log(searchParams);
    console.log('---------------');

    // Add safe, URL encoded search parameter if there is a search term
    const options = { params: searchParams };

    return this.http.get<CuttingTableType[]>(this.globals.apiUrl + '/cutting_tableType', options)
      .pipe(
        tap(  _ => this.log('get cutting_table type')),
        catchError(this.handleError<CuttingTableType[]>('getCuttingTableTypes', null)
      ));

  }

  updateCuttingTable(cutting_tableIn: CuttingTable): Observable<CuttingTable> {

    console.log('-->--> Ejecutando servicio updateCuttingTable');
    console.log(cutting_tableIn);
    console.log('---------------');

    let options = {};
    if (cutting_tableIn.id === null) {
      options = { params: new HttpParams()
        .set('id', '0') };
    } else {
      options = { params: new HttpParams()
        .set('id', cutting_tableIn.id.toString()) };
    }

    return this.http.put<CuttingTable>(this.globals.apiUrl + '/cutting_table', cutting_tableIn, options)
      .pipe(
        tap(  _ => this.log('updated cutting_table')),
        catchError(this.handleError<CuttingTable>('updateCuttingTable', null)
      ));
  }

  createCuttingTable(cutting_tableIn: CuttingTable): Observable<CuttingTable> {

    console.log('-->--> Ejecutando servicio createCuttingTable');
    console.log(cutting_tableIn);
    console.log('---------------');

    const options = {};

    return this.http.post<CuttingTable>(this.globals.apiUrl + '/cutting_table', cutting_tableIn, options)
      .pipe(
        tap(  _ => this.log('created cutting_table')),
        catchError(this.handleError<CuttingTable>('createCuttingTable', null)
      ));
  } // End function createCuttingTable

  deleteCuttingTable(cutting_tableIn: CuttingTable): Observable<bigint> {

    console.log('-->--> Ejecutando servicio deleteCuttingTable');
    console.log(cutting_tableIn);
    console.log('---------------');

    let options = { params: new HttpParams()
        .set('id', cutting_tableIn.id.toString()) };

    return this.http.delete<bigint>(this.globals.apiUrl + '/cutting_table', options)
      .pipe(
        tap(  _ => this.log('deleted cutting_table')),
        catchError(this.handleError<bigint>('deleteCuttingTable', null)
      ));
  } // End function deleteCuttingTable

  normalizeCuttingTables(): Observable<any> {
    console.log('-->--> Ejecutando servicio normalizeCuttingTables');
    const options = {};
    return this.http.put<any>(this.globals.apiUrl + '/cutting_table_normalize', {}, options)
      .pipe(
        tap( _ => this.log('normalized cutting_tables')),
        catchError(this.handleError<any>('normalizeCuttingTables', null))
      );
  }

  // Servicio para obtener los agentes comerciales.
  getUsers(): Observable<User[]> {

    console.log('-->--> Ejecutando servicio getUsers');

    return this.http.get<User[]>(this.globals.apiUrl + '/users')
      .pipe(
        tap( data => console.log(' -> Comerciales obtenidos desde getUsers.')),
        catchError(this.handleError<User[]>('getUsers', [])
      ));
  }

  /** Log a HeroService message with the MessageService */
  private log(message: string) {
    this.messageService.add(`HeroService: ${message}`);
  }

  // -------------------------

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error (error); // lot to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // TODO: Let the app keep running by returning an empty result.
      return of (result as T);
    };
  }

}
